import Mock from 'mockjs';
import { isSSR } from '@gbi/shared/utils/common';
import setupMock from '@/utils/setupMock';
import { generatePermission } from '@/routes';

if (!isSSR) {
  Mock.XHR.prototype.withCredentials = true;

  setupMock({
    setup: () => {
      // 用户信息
      const userRole = window.localStorage.getItem('userRole') || 'admin';
      Mock.mock(new RegExp('/api/user/userInfo'), () => {
        // 根据角色生成不同的权限
        let permissions;
        if (userRole === 'admin') {
          // 管理员：所有权限
          permissions = generatePermission(userRole);
        } else if (userRole === 'user-with-ai') {
          // 有 AI 助手权限的普通用户
          permissions = {
            'data-intelligence/policy-qa': ['*'],
            'content-source/policy': ['read'],
            'dashboard/workplace': ['read'],
          };
        } else {
          // 无 AI 助手权限的普通用户
          permissions = {
            'content-source/policy': ['read'],
            'dashboard/workplace': ['read'],
          };
        }
        
        return Mock.mock({
          name: userRole === 'admin' ? 'admin' : 'user',
          avatar: 'https://oss.v-dk.com/img/202503182349102.svg',
          email: 'wangliqun@email.com',
          job: 'frontend',
          jobName: '前端开发工程师',
          organization: 'Frontend',
          organizationName: '前端',
          location: 'beijing',
          locationName: '北京',
          introduction: '王力群并非是一个真实存在的人。',
          personalWebsite: 'https://www.arco.design',
          verified: true,
          phoneNumber: /177[*]{6}[0-9]{2}/,
          accountId: /[a-z]{4}[-][0-9]{8}/,
          registrationTime: Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
          permissions: permissions,
        });
      });

      // 登录
      Mock.mock(new RegExp('/api/user/login'), (params) => {
        const { userName, password } = JSON.parse(params.body);
        if (!userName) {
          return {
            status: 'error',
            msg: '用户名不能为空',
          };
        }
        if (!password) {
          return {
            status: 'error',
            msg: '密码不能为空',
          };
        }
        if (userName === 'admin' && password === 'admin') {
          return {
            status: 'ok',
          };
        }
        return {
          status: 'error',
          msg: '账号或者密码错误',
        };
      });
    },
  });
}
